import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import {UserListItemInfo} from "../model/user-list-item-info";

@Injectable()
export class UserService {

  constructor(private httpClient: HttpClient) {
  }

  private baseUrl = '/api/user';

  getUsers(): Observable<UserListItemInfo[]> {
    return this.httpClient.get<UserListItemInfo[]>(this.baseUrl);
  }

  deleteUser(id: string): Promise<any> {
    return this.httpClient.delete(`${this.baseUrl}/${id}`).toPromise();
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/service/user.service.ts